import axiosOrders from '../../axios/quickOrders';
var qs = require( 'qs' ); // necessary for stringifying json for http requests to API

import router from '../../router/router';
import { routes } from '../../router/routes';
import { store } from '../store';
// resources:
//  https://morningstar.engineering/managing-your-vue-js-applications-state-with-vuex-part-2-5e5c3a0cd507
//  https://stackoverflow.com/questions/46234832/structuring-a-vuex-module

// indexDB reference: https://developers.google.com/web/ilt/pwa/lab-indexeddb
import idb from 'idb';

const state = {

    ordersCached : JSON.parse( localStorage.getItem( 'ordersCached' ) ) || null,
    pastOrders   : [],
    currentOrder : JSON.parse( localStorage.getItem( 'currentOrder' ) ) || null,
    currentPage  : 1,
    pageLimit    : 10,
    totalOrders  : JSON.parse( localStorage.getItem( 'totalOrders' ) ) || 0,
    activeOrder  : JSON.parse( localStorage.getItem( 'activeOrder' ) ) || null,
};

const mutations = {

    setOrders( state, data ){

        console.log( 'data coming through..', data );
        if( Object.keys( data.body ).length > 0 ){

            let dbPromise = idb.open( 'quickOrdersDB', data.idbVersion );
            dbPromise.then( db => {

                var txPastOrders;
                try {
                    txPastOrders = db.transaction( 'pastOrders', 'readwrite' );
                } catch( e ) {
                    store.dispatch( 'fixMissingObjectStore', e );
                }

                txPastOrders.objectStore( 'pastOrders' ).clear();
                state.pastOrders = [];
                Object.values( data.body ).forEach( value => {

                    // console.log( 'order data: ', value );
                    txPastOrders.objectStore( 'pastOrders' ).put( value );
                    state.pastOrders.push( value );
                });
            });
        }

        state.totalOrders = data.totalOrders;
        localStorage.setItem( 'totalOrders', data.totalOrders );

        const timestamp = parseInt( new Date().getTime() );
        state.ordersCached = timestamp;
        localStorage.setItem( 'ordersCached', timestamp );
    },
    viewOrder( state, orderId ){

        localStorage.setItem( 'currentOrder', orderId );
        state.currentOrder = orderId;
    },
    clearState( state ){

        state.pastOrders = [];

        state.ordersCached = null;
        localStorage.removeItem( 'ordersCached' );

        state.currentOrder = null;
        localStorage.removeItem( 'currentOrder' );

        state.activeOrder = null;
        localStorage.removeItem( 'activeOrder' );

        state.currentPage = 1;
        state.pageLimit   = 10;

        state.totalOrders = 0;
        localStorage.removeItem( 'totalOrders' );
    },
    pageOrders( state, direction ){

        state.currentPage += direction;
    }
};

const actions = {

    getOrders( { commit, dispatch, getters, rootGetters }, paging = false ){

        console.log( 'init..' );
        if( paging || getters.ordersCached == null || parseInt( getters.ordersCached ) + parseInt( 5 * 60 * 1000 ) < parseInt( new Date().getTime() ) ){ // redundant double-guard

            console.log( 'got within..' );
            axiosOrders({

                method: 'post',
                url: '/getUsersOrders',
                data: qs.stringify( {

                    merchantId  : rootGetters[ 'merchant/currentMerchant' ].merchantId,
                    currentPage : getters.currentPage,
                    count       : getters.pageLimit
                } ),
            }).then( res => {

                console.log( 'result get orders: ', res.data );
                if( res.data.responseCode == 100 ){

                    // run a diff
                    if( getters.pastOrders.length > 0 ){ // we have some currently loaded

                        Object.values( res.data.body ).forEach( ( order, key ) => {

                            for( let i = 0; i < getters.pastOrders.length; i++ ){

                                if( order.quickOrderId == getters.pastOrders[ i ].quickOrderId ){

                                    Object.values( res.data.body )[ key ].alreadyExists = true;
                                    break;
                                }
                            }
                        });

                        const newOrders = Object.values( res.data.body ).filter( order => !order.alreadyExists );
                        const payload = {

                            body        : newOrders, // only push the new ones not previously seen
                            idbVersion  : rootGetters[ 'idbVersion' ],
                            totalOrders : res.data.totalOrders
                        };
                        commit( 'setOrders', payload );
                    } else {

                        const payload = {

                            body        : res.data.body,
                            idbVersion  : rootGetters[ 'idbVersion' ],
                            totalOrders : res.data.totalOrders
                        };
                        commit( 'setOrders', payload );
                    }
                } else {

                    console.log( 'server error' );
                }
            }).catch( err => {

                console.error( 'error! ', err );
                dispatch( 'updateLoadingStatus', 'Error Processing!', { root : true } )
            });
        }
    },
    viewOrder( { commit, rootGetters }, order ){

        commit( 'viewOrder', order.quickOrderId );
        router.push({

            name: 'view-order',
            params: { slug : rootGetters[ 'merchant/merchantSlug' ] }
        });
    },
    setActiveOrder( state, order ) {
        const today = new Date();
        const date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        const dateTime = date +' '+ time;

        const newOrderData = {
            uuid: order.uuid,
            deliveryFee: order.deliveryFee,
            timestamp: dateTime
        }

        console.log(newOrderData)
        localStorage.setItem( 'activeOrder', JSON.stringify( newOrderData ) );
    },
    clearState( { commit, dispatch, rootGetters } ){

        let dbPromise = idb.open( 'quickOrdersDB', rootGetters.idbVersion );
        dbPromise.then( db => {

            var txPastOrders;
            try {
                txPastOrders = db.transaction( 'pastOrders', 'readwrite' );
            } catch( e ) {
                store.dispatch( 'fixMissingObjectStore', e );
            }

            txPastOrders.objectStore( 'pastOrders' ).clear();
        });
        commit( 'clearState' );
    },
    pageOrders( { commit, dispatch, getters }, direction ){

        if( direction == -1 && getters.currentPage <= 1 ){

            // do nothing, at lowest page
        } else if( direction == 1 && getters.currentPage >= getters.totalPages ){

            // do nothing, at highest page
        } else {

            commit( 'pageOrders', direction );
            dispatch( 'getOrders', true );
        }
    },
    generateUuidOrder(){
        let uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
        return uuid;
    }
};

const getters = {

    ordersCached : state => state.ordersCached,
    pastOrders   : state => state.pastOrders.sort( ( a, b ) => b.quickOrderId - a.quickOrderId ),
    currentOrder( state ){

        return state.pastOrders.filter( order => {

            if( order.quickOrderId == state.currentOrder ) return order;
        })[ 0 ];
    },
    getActiveOrder : state => state.activeOrder,
    currentPage : state => state.currentPage,
    pageLimit   : state => state.pageLimit,
    totalOrders : state => state.totalOrders,
    totalPages( state ){

        return Math.ceil( state.totalOrders / state.pageLimit );
    }
};

export default {

    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
